'use strict';

import $ from 'jquery';

export default class UpcomingProgrammes {
  constructor() {

    $('.course-tabs li').click(function(){
      var tab_id = $(this).attr('data-tab');

      $('.course-tabs li').removeClass('current');
      $('.tab-content').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');

    });

  }
}
